import { render, staticRenderFns } from "./cardEditForm.vue?vue&type=template&id=63455178"
import script from "./cardEditForm.vue?vue&type=script&lang=js"
export * from "./cardEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports